import React from "react";
import { useOrderIndStatusTypes } from "../../../data/initialData/hooks/useOrderIndStatus";
import { OrderIndStatuses } from "../../../data/models";
import { AutocompleteSelectType, AutocompleteSelect } from "./AutocompleteSelect";


type OrderIndStatusPropsType = Omit<AutocompleteSelectType<OrderIndStatuses>, "data" | "getLabel">;

export const OrderIndStatus: React.FunctionComponent<OrderIndStatusPropsType> = (props) => {
	const [orderIndStatus, renderLabel] = useOrderIndStatusTypes();

	return (
		<AutocompleteSelect<OrderIndStatuses>
			data={orderIndStatus}
			getLabel={renderLabel}
			{...(props as any)}
		/>
	);
};


